import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function Stepper({
  steps,
  currentStep,
  onStepClick,
  isStepDisabled,
}) {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-mb-8">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className={`tw-flex tw-flex-col tw-items-center tw-flex-1 ${
              onStepClick && !isStepDisabled?.(index) ? 'tw-cursor-pointer' : ''
            }`}
            onClick={() =>
              onStepClick && !isStepDisabled?.(index) && onStepClick(index)
            }
          >
            <div
              className={`tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-full tw-border-2 tw-transition-all ${
                index < currentStep
                  ? 'tw-bg-main tw-border-main tw-text-white'
                  : index === currentStep
                    ? 'tw-bg-white tw-border-main tw-text-main'
                    : 'tw-bg-white tw-border-gray-300 tw-text-gray-400'
              }`}
            >
              {index < currentStep ? (
                <FontAwesomeIcon icon={faCheck} className="tw-text-sm" />
              ) : (
                <span className="tw-font-semibold">{index + 1}</span>
              )}
            </div>
            <div
              className={`tw-mt-2 tw-text-xs tw-font-medium tw-text-center ${
                index <= currentStep ? 'tw-text-main' : 'tw-text-gray-400'
              }`}
            >
              {step.label}
            </div>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`tw-flex-1 tw-h-0.5 tw-mx-2 tw-mb-6 tw-transition-all ${
                index < currentStep ? 'tw-bg-main' : 'tw-bg-gray-300'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
